import React from 'react';
import { map } from 'lodash';
import PercentageValue from '../../../common/PercentageValue';
import CountryFlag from '../../../common/CountryFlag';
import { percentageValue, splitByThousands } from '../../../../helpers/NumberFormatter';
import DiffAndChange from '../../../common/DiffAndChange';
import AbsoluteValue from '../../../common/AbsoluteValue';

export const territorySettings = {
    settingsForTable
};


function settingsForTable(prevPeriod) {

    let columns = [
        {
            id: 'logo',
            className: 'logo-sell',
            headerClassName: 'logo-sell',
            Header: '',
            accessor: 'name',
            width: 43,
            Cell: props => {
                return <CountryFlag className="flag-default" country={props.original.code} />
            }
        },
       {
           id: 'name',
           className: 'table-text-left', 
           headerClassName: 'table-text-left no-sort',
           Header: 'Country',
           accessor: 'name',
           width: 200,
           Cell: props => <span>{props.value}</span>
       },
       {
            id: 'physical_income',
            className: 'table-text-right', 
            headerClassName: 'table-text-right no-sort',
            Header: props => <span>Physical Income <br /> Physical Qty</span>,
            accessor: 'physical_income',
            Cell: props => <span className="absolute-vendor-value">
                <AbsoluteValue currency={true} value={props.original.curr_physical_income}></AbsoluteValue>
                <AbsoluteValue currency={false} value={props.original.curr_physical_quantity}></AbsoluteValue>
            </span>,
       },       
       {
            id: 'physical_change',
            className: 'table-text-right unit-change-cell', 
            headerClassName: 'table-text-right no-sort unit-change-cell',
            Header: props => <span>Physical Income Change <br/> Physical Qty Change</span>,
            accessor: 'physical_change',
            Cell: props => <span> 
                <DiffAndChange currency={true} className="percent-value" field="physical_income" item={props.original}/>
                <DiffAndChange currency={false} className="percent-value" field="physical_quantity" item={props.original}/>
            </span>,
            width: 130,
            show: prevPeriod
       },       
       {
            id: 'digital_income',
            className: 'table-text-right', 
            headerClassName: 'table-text-right no-sort',
            Header: props => <span>Digital Income <br /> Digital Qty</span>,
            accessor: 'digital_income',
            Cell: props => <span className="absolute-vendor-value"> 
                <AbsoluteValue currency={true} value={props.original.curr_digital_income}></AbsoluteValue>
                <AbsoluteValue currency={false} value={props.original.curr_digital_quantity}></AbsoluteValue>
            </span>,
       },
       {
            id: 'digital_change',
            className: 'table-text-right unit-change-cell', 
            headerClassName: 'table-text-right no-sort unit-change-cell',
            Header: props => <span>Digital Income Change <br/> Digital Qty Change</span>,
            accessor: 'digital_change',
            Cell: props => <span> 
                <DiffAndChange currency={true} className="percent-value" field="digital_income" item={props.original}/>
                <DiffAndChange currency={false} className="percent-value" field="digital_quantity" item={props.original}/>
            </span>,
            width: 130,
            show: prevPeriod
       },
       {
            id: 'nr_income',
            className: 'table-text-right', 
            headerClassName: 'table-text-right no-sort',
            Header: props => <span>NR Income <br /> NR Qty</span>,
            accessor: 'nr_income',
            Cell: props => <span className="absolute-vendor-value"> 
                <AbsoluteValue currency={true} value={props.original.curr_nr_income}></AbsoluteValue>
                <AbsoluteValue currency={false} value={props.original.curr_nr_quantity}></AbsoluteValue>
            </span>,
        },       
       {
            id: 'nr_change',
            className: 'table-text-right unit-change-cell', 
            headerClassName: 'table-text-right no-sort unit-change-cell',
            Header: props => <span>NR Income Change <br/> NR Qty Change</span>,
            accessor: 'nr_change',
            Cell: props => <span> 
                <DiffAndChange currency={true} className="percent-value" field="nr_income" item={props.original}/>
                <DiffAndChange currency={false} className="percent-value" field="nr_quantity" item={props.original}/>
            </span>,
            width: 130,
            show: prevPeriod
        },         
       {
            id: 'total_income',
            className: 'table-text-right', 
            headerClassName: 'table-text-right no-sort',
            Header: props => <span>Total Income <br /> Total Qty</span>,
            accessor: 'total_income',
            Cell: props => <span className="absolute-vendor-value"> 
                <AbsoluteValue currency={true} value={props.original.curr_total_income}></AbsoluteValue>
                <AbsoluteValue currency={false} value={props.original.curr_total_quantity}></AbsoluteValue>
            </span>,
       },
       {
            id: 'total_change',
            className: 'table-text-right unit-change-cell', 
            headerClassName: 'table-text-right no-sort unit-change-cell',
            Header: props => <span>Total Income Change <br /> Total Qty Change</span>,
            accessor: 'total_change',
            Cell: props => <span> 
                <DiffAndChange currency={true} className="percent-value" field="total_income" item={props.original}/>
                <DiffAndChange currency={false} className="percent-value" field="total_quantity" item={props.original}/>
            </span>,
            width: 130,
            show: prevPeriod
       },
       {
            id: 'share',
            className: 'table-text-right', 
            headerClassName: 'table-text-right no-sort',
            footerClassName: 'table-text-right',
            Header: props => <span>Total Income<br /> Share</span>,
            // Cell: props => <PercentageValue field="playlists" item={props.original}></PercentageValue>,
            // width: 70,
            accessor: 'share',
            Cell: props => <span>{props.value}%</span>,
       },       
    ];
    return columns;
}
